import GLightbox from "glightbox";
export default ($) => {
  const profilePopupTriggers = $('.js-fetchProfile');

  profilePopupTriggers.on('click', async function (e) {
    e.preventDefault();
    let _this = $(this);
    let ID = _this.data('id');

    const { ajaxurl } = wp_params;

    if (!ID) {
      console.error("No ID provided for the profile popup.");
      return;
    }

    try {
      const response = await $.ajax({
        url: ajaxurl,
        type: 'POST',
        data: {
          action: 'load_profile_popup',
          termId: ID
        }
      });

      const lightbox = GLightbox({
        elements: [{
          content: response,
          type: 'inline'
        }],
        touchNavigation: false,
        width: "920px",
        height: "auto",
      });

      lightbox.open();
    } catch (error) {
      console.error("Error loading profile popup:", error);

      const lightbox = GLightbox({
        elements: [{
          content: `<div>Error loading profile content. Please try again later.</div>`,
          type: 'inline'
        }]
      });

      lightbox.open();
    }
  });
}